export const module = {
  info: {
    name: 'voip-lcr-top-destinations',
    caption: 'voip-lcr-top-destinations'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  // noRoutes: true,
  /*sideMenu: {
    topSeparator: false,
    caption: 'LCR Top Destinations',
    icon: 'el-icon-star-on',
    routeName: 'module->voip-lcr-top-destinations->lcr->top-destination->list->page',
    routeParams: { listPage: 1},
  }*/
}

export default module
